import React from "react";

const OptionGroup = props => <optgroup {...props} />;

export default OptionGroup;
